export default "__VITE_ASSET__d53e64f1__"